import React from 'react';
import { AssetHealthStatusIndicator } from '@/components/pages/AssetsPreviewPage/shared/AssetHealthStatusIndicator';
import { SensorsData } from '../../shared/SensorsIndicator/SensorsData';
import { Asset } from '@/types/models/assets.types';
import { AssetLastVerified } from '../../shared/AssetLastVerified';
import { cn } from '@/lib/utils';
import { StatusChanged } from '../../shared/StatusChanged';
import { AssetActionsBar, SensorsNewIndicator } from '../../shared';
import { HEALTH_STATUS } from '@/const';
import { healthStatusFlagsToString } from '@/utils/shared';

interface BodySectionProps {
  asset: Asset;
  isRequireAttention: boolean;
  classNames?: {
    assetsFaultIndicator?: string;
  };
}
const assetsFaultIndicatorStyle = 'flex items-center gap-3 overflow-hidden  whitespace-nowrap pt-2 w-full';

const BodySectionComponent = ({ asset, classNames, isRequireAttention }: BodySectionProps) => {
  return (
    <>
      <div className={cn('flex justify-between items-center ')}>
        <div className={cn(` flex-1`, `${isRequireAttention ? 'pb-2' : ''}`)}>
          <div
            className={cn(
              classNames?.assetsFaultIndicator || assetsFaultIndicatorStyle,
              `flex-col gap-1 pb-1 items-start`
            )}
          >
            <div className="flex justify-between w-full">
              <AssetHealthStatusIndicator
                healthStatus={asset.health_status}
                showReasons={true}
                reasons={asset.health_status_comments || healthStatusFlagsToString(asset)}
              />
            </div>
            <AssetLastVerified lastVerified={asset.latest_diagnostic_created_at} />
          </div>
        </div>
        <div
          className={cn(
            'flex items-center justify-end gap-2 h-full'
            // asset.health_status === HEALTH_STATUS.NOT_AVAILABLE || asset.not_monitored ? 'grayscale' : ''
          )}
        >
          <AssetActionsBar asset={asset} />
          <SensorsNewIndicator
            asset={asset}
            isNA={asset.health_status === HEALTH_STATUS.NOT_AVAILABLE || asset.not_monitored}
          />
        </div>
      </div>
    </>
  );
};

export const BodySection = React.memo(BodySectionComponent);
